import { render, staticRenderFns } from "./RegistrationOTPModal.vue?vue&type=template&id=1cba1a06&scoped=true&"
import script from "./RegistrationOTPModal.vue?vue&type=script&lang=js&"
export * from "./RegistrationOTPModal.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationOTPModal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./RegistrationOTPModal.vue?vue&type=style&index=1&id=1cba1a06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cba1a06",
  null
  
)

export default component.exports